module.exports = "/_next/static/images/a4bf8bd7e2dc7656db9ee0519d14f5b8-define-investment.png.webp";